// extracted by mini-css-extract-plugin
export default {"Newsfeed":"Newsfeed_Newsfeed__N+02g"};